// extracted by mini-css-extract-plugin
module.exports = {"button":"Settings_button__oNHuA","tourEdit":"Settings_tourEdit__XWPFY","tourStatus":"Settings_tourStatus__3HneT"};